import * as actions from "./addressGetActions";
import { ADDRESSES_GET_REQUEST_SUCCESS } from "@p81-common/shell-core-js/dist/redux/addressesGet";
import { ADDRESSES_POST_REQUEST_SUCCESS } from "store/api/organization/addressesPost/addressesPostActions";
import { ADDRESSES_PUT_REQUEST_SUCCESS } from "store/api/organization/addressesPut/addressesPutActions";
import { CURRENT_CHILD_ORGANIZATION_SET } from "store/domain/currentChildOrganization/currentChildOrganizationActions";
import { arrayToMap } from "@p81-common/shell-core-js";

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [actions.ADDRESS_GET_REQUEST]: (state, action) => ({
    ...state,
    [action.id]: {
      loading: true,
      loaded: false,
      error: null,
      data: state[action.id] && state[action.id].data,
    },
  }),

  [actions.ADDRESS_GET_REQUEST_SUCCESS]: (state, action) => ({
    ...state,
    [action.id]: {
      loading: false,
      loaded: true,
      error: null,
      data: action.data,
    },
  }),

  [ADDRESSES_POST_REQUEST_SUCCESS]: (state, action) => {
    if (!action.data.address) return state;
    return {
      ...state,
      [action.data.address.id]: {
        loading: false,
        loaded: true,
        error: null,
        data: action.data.address,
      },
    };
  },

  [ADDRESSES_PUT_REQUEST_SUCCESS]: (state, action) => {
    if (!action.data.address) return state;
    return {
      ...state,
      [action.data.address.id]: {
        loading: false,
        loaded: true,
        error: null,
        data: action.data.address,
      },
    };
  },

  [actions.ADDRESS_GET_REQUEST_FAILURE]: (state, action) => ({
    ...state,
    [action.id]: {
      loading: false,
      loaded: false,
      error: action.error,
      data: null,
    },
  }),


  [actions.ADDRESS_GET_RESET]: (state, action) => initialState,

  [CURRENT_CHILD_ORGANIZATION_SET]: () => initialState,
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {};

export default function addressGetReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
